/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Card,
  FormControl,
  FormHelperText,
  Grid,
} from "@mui/material";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import PhoneInput, {
  formatPhoneNumberIntl,
  isValidPhoneNumber,
} from "react-phone-number-input";
import "react-phone-number-input/style.css";
import HlxButton from "../../commonComponents/button/button.tsx";
import "./contactCard.scss";
import GeneralDialog from "component/dialogComponents/generalDialog/generalDialog";
import Textbox from "component/commonComponents/Textbox";
import SelectBox from "component/commonComponents/selectBox";
import { StyledAsterisk } from "component/commonComponents/Textbox/Textbox.style";
import { ButtonLink } from "../deliveryCardComponent/deliveryCard.style";

const defaultAddress = {
  // contactName: "",
  phoneNumber: "",
  firstName: "",
  lastName: "",
  phoneType: "Home",
};
function AddressDialog(props) {
  const { onClose, open, addressItem, phoneType, defaultCountry, locale } =
    props;
  const isLoading = false;
  // const errorMsg = '';
  const [originalAddress, setOriginalAddress] = useState(addressItem);
  const [address, setAddress] = useState(originalAddress);
  const [validationFields, setValidationFields] = useState({
    phoneNumber: true,
    firstName: true,
    lastName: true,
  });
  useEffect(() => {
    setValidationFields({
      ...validationFields,
      phoneNumber: address["phoneNumber"]
        ? isValidPhoneNumber(address["phoneNumber"])
        : validationFields.phoneNumber,
    });
  }, [address["phoneNumber"]]);

  useEffect(() => {
    if (open) {
      setOriginalAddress(addressItem);
      setAddress(addressItem);
      setValidationFields({
        phoneNumber: true,
        firstName: true,
        lastName: true,
      });
    }
  }, [open]);

  const handleChange = (event, fieldName) => {
    setAddress({
      ...address,
      [fieldName]:
        fieldName === "phoneNumber"
          ? event
          : fieldName === "phoneType"
          ? event.value
          : event.target.value,
    });
  };

  const validateField = (fieldName) => {
    if (fieldName === "phoneNumber") {
      setValidationFields({
        ...validationFields,
        [fieldName]: address[fieldName]
          ? isValidPhoneNumber(address[fieldName])
          : !!address[fieldName],
      });
    } else {
      setValidationFields({
        ...validationFields,
        [fieldName]: !!address[fieldName],
      });
    }
  };

  const handleClose = async (event, isUpdateAddress = false) => {
    let isValid = true,
      validFields = {};
    if (document.activeElement instanceof HTMLElement)
      document.activeElement.blur();
    Object.keys(validationFields).forEach((ele) => {
      if (!address[ele]) isValid = false;
      validFields = {
        ...validFields,
        [ele]: !!address[ele],
      };

      if (
        ele === "phoneNumber" &&
        address[ele] &&
        !isValidPhoneNumber(address[ele])
      ) {
        isValid = false;
        validFields = {
          ...validFields,
          [ele]: isValid,
        };
      }
    });

    if (isUpdateAddress) {
      setValidationFields({
        ...validationFields,
        ...validFields,
      });
    }

    if (isUpdateAddress) {
      if (isValid) onClose(address, isUpdateAddress);
    } else {
      onClose(originalAddress, isUpdateAddress);
    }
  };

  const buttonSubmit = (
    <>
      <HlxButton
        onClick={(event, reason) => handleClose(event, true)}
        loading={isLoading}
        label={locale?.txtOk}
        id="btn-contactcard-ok"
      />
    </>
  );

  const content = (
    <>
      <Grid container>
        <Grid container xs={6} item>
          <Grid xs={12} item>
            <Textbox
              label={locale?.firstName}
              boldLabel
              labelSize="small"
              type="text"
              name="firstName"
              value={address.firstName}
              error={!validationFields.firstName}
              onChange={(e) => handleChange(e, "firstName")}
              onBlur={(e) => validateField("firstName")}
              fullWidth
              required
              textboxToolTip={locale?.textboxToolTip}
              id="txt-contactcard-first_name"
            />
          </Grid>
        </Grid>

        <Grid container xs={6} item>
          <Grid xs={12} item>
            <Textbox
              type="text"
              label={locale?.lastName}
              boldLabel
              labelSize="small"
              name="lastName"
              value={address.lastName}
              onChange={(e) => handleChange(e, "lastName")}
              onBlur={(e) => validateField("lastName")}
              error={!validationFields.lastName}
              fullWidth
              required
              textboxToolTip={locale?.textboxToolTip}
              id="txt-contactcard-last_name"
            />
          </Grid>
        </Grid>
      </Grid>

      <Grid container className="mt-20">
        <Grid xs={6} md={8} container item>
          <Grid xs={12} item>
            <label>{locale?.phoneNumber}</label>
          </Grid>
          <Grid xs={12} item>
            <div className="PhoneInputWrapper">
              <PhoneInput
                className={
                  !validationFields.phoneNumber
                    ? "PhoneNumberError"
                    : "PhoneNumberDefault"
                }
                name="phoneNumber"
                placeholder={locale?.phoneNumberPlaceholder}
                defaultCountry={defaultCountry}
                country={defaultCountry}
                international
                withCountryCallingCode
                options={"US"}
                value={address.phoneNumber}
                onChange={(e) => handleChange(e, "phoneNumber")}
                onBlur={() => validateField("phoneNumber")}
                title={locale?.textboxToolTip}
                id="drp-contactcard-phone_number"
              />
            </div>
          </Grid>
        </Grid>

        <Grid xs={6} md={4} container item>
          <Grid xs={12} item>
            <FormControl
              width="100%"
              className="select-address-dialog"
              style={{ display: "block" }}
            >
              <SelectBox
                labelId="phoneType"
                name="phoneType"
                label={locale?.phoneTypeLabel}
                boldLabel
                value={
                  phoneType.find((type) => type.value === address.phoneType) ||
                  ""
                }
                handleChange={(e, val) => handleChange(val, "phoneType")}
                fullWidth
                variant="outlined"
                options={phoneType}
                disableClearable
                textboxToolTip={locale?.textboxToolTip}
                locale={locale}
                id={"drp-contactcard-phone_type"}
              />
            </FormControl>
          </Grid>
        </Grid>
      </Grid>
      {!validationFields.phoneNumber && (
        <p className="err-msg">
          <i>{locale?.invalidPhoneNumber}</i>
        </p>
      )}
    </>
  );

  return (
    <GeneralDialog
      title={locale?.updateContact}
      content={content}
      isOpen={open}
      handleClose={(event) => handleClose(event, false)}
      showComment={false}
      buttonSubmit={buttonSubmit}
      deviders={false}
      headerBackgroundDefault={false}
      cancelLabel={locale?.txtCancel}
      classname="delivery-address-dialog"
    />
  );
}

AddressDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  defaultCountry: PropTypes.string,
  locale: PropTypes.object,
};

AddressDialog.defaultProps = {
  defaultCountry: "US",
  locale: {
    id: "577d019b-d408-4ee2-95f6-0018c094a556",
    updateContact: "Update Contact",
    firstName: "First name",
    lastName: "Last name",
    phoneNumber: "Phone Number",
    phoneNumberPlaceholder: "Enter phone number",
    invalidPhoneNumber: "Invalid Phone Number",
    phoneTypeLabel: "Phone Type",
    phoneType: {
      Mobile: "Mobile",
      Home: "Home",
      Work: "Work",
    },
    phoneTypeNumber: "Phone Type: Number",
    editContact: "Edit Contact",
    txtOk: "OK",
    txtCancel: "CANCEL",
  },
};

const ContactCard = (props) => {
  const { defaultCountry, disabled, locale, handleEdit, required } = props;

  const [open, setOpen] = React.useState(false);
  const [address, setAddress] = React.useState(
    !!props.addressItem ? props.addressItem : defaultAddress
  );
  const handleClickOpen = () => {
    setOpen(true);
  };

  const phoneType = Object.entries(locale?.phoneType).map((type) => {
    return {
      value: type[0],
      name: type[1],
    };
  });
  const { error, errorText } = props;
  const handleClose = (address, isUpdateAddress = true) => {
    setOpen(false);
    if (isUpdateAddress) {
      setAddress(address);
      props.onChange(address);
    }
  };

  return (
    <div className="uptime-delivery-card">
      <h5 className="heading5">
        {props.title}
        {required && <StyledAsterisk>*</StyledAsterisk>}
      </h5>
      <Card className="card-wrap">
        <FormControl error={error} className="uptime-delivery-card-body">
          <Grid container>
            <Grid xs={8} item>
              <Box className="content-box">
                {/* <p key={1} className="bodyBold">{address.contactName}</p> */}
                <p key={2} className="bodyRegular">
                  {address.firstName} {address.lastName}
                </p>
                {address.phoneType && address.phoneNumber ? (
                  <p key={3} className="bodyRegular">
                    {locale?.phoneType[address.phoneType]} :{" "}
                    {formatPhoneNumberIntl(address.phoneNumber)}
                  </p>
                ) : (
                  <p key={3} className="bodyRegular">
                    {locale?.phoneTypeNumber}
                  </p>
                )}
              </Box>
            </Grid>
            <Grid xs={4} item>
              {
                <ButtonLink
                  className="buttonLink"
                  onClick={!disabled ? handleClickOpen : handleEdit}
                  id={'btn-contactcard-update'}
                >
                  {address.phoneType && address.phoneNumber
                    ? locale?.editContact
                    : locale?.addContact}
                </ButtonLink>
              }
            </Grid>
          </Grid>
          {error && (
            <FormHelperText id="my-helper-text">{errorText}</FormHelperText>
          )}
        </FormControl>
      </Card>
      <AddressDialog
        open={open}
        onClose={handleClose}
        addressItem={address}
        phoneType={phoneType}
        defaultCountry={defaultCountry}
        locale={locale}
      />
    </div>
  );
};

ContactCard.propTypes = {
  title: PropTypes.string,
  addressItem: PropTypes.object,
  defaultCountry: PropTypes.string,
  onChange: PropTypes.func,
  error: PropTypes.bool,
  errorText: PropTypes.string,
  disabled: PropTypes.bool,
  locale: PropTypes.object,
  handleEdit: PropTypes.func,
  required: PropTypes.bool,
};

ContactCard.defaultProps = {
  title: "Deliver Contact To:",
  error: false,
  errorText: "Please update your address",
  disabled: false,
  required: false,
  addressItem: {
    ...defaultAddress,
  },
  defaultCountry: "US",
  onChange: (address) => {
    console.log(address);
  },
  locale: {
    id: "577d019b-d408-4ee2-95f6-0018c094a556",
    updateContact: "Update Contact",
    firstName: "First name",
    lastName: "Last name",
    phoneNumber: "Phone Number",
    phoneNumberPlaceholder: "Enter phone number",
    invalidPhoneNumber: "Invalid Phone Number",
    phoneTypeLabel: "Phone Type",
    phoneType: {
      Mobile: "Mobile",
      Home: "Home",
      Work: "Work",
    },
    phoneTypeNumber: "Phone Type: Number",
    editContact: "Edit Contact",
    addContact: "Add Contact",
  },
  handleEdit: () => {
    console.log("Jump to step");
  },
};

export default ContactCard;
